import { ToolTip, Typography } from '@libs/components';
import styled from 'styled-components';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  width: 100%;
  padding: 0 1.6rem;

  ${({ theme }) => theme.media.laptop`
    padding: 0;
  `}
`;

export const StatisticsWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.borderRadius.x3};
  border: 1px solid ${({ theme }) => theme.colors.borders.default};
`;

export const StatRow = styled.div<{ hasBorder: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 7.6rem;
  padding: 1.6rem;
  border-bottom: 1px solid
    ${({ theme, hasBorder }) =>
      hasBorder ? theme.colors.borders.default : 'transparent'};
`;

export const Row = styled.div`
  display: flex;
  flex-direction: 'row';
  align-items: 'center';
  gap: 0.8rem;
`;

export const RowLeftComponentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;
export const CustomTypography = styled(Typography)`
  text-align: 'right';
  display: flex;
`;

export const ProgressBarWrapper = styled.div`
  max-width: 1.6rem;
`;

export const CustomTooltip = styled(ToolTip)`
  display: none;
  ${({ theme }) => theme.media.tablet`
      display:block;
  `};
  .desc {
    color: ${({ theme }) => theme.colors.text.secondary};
  }
  svg {
    width: 2.2rem;
    height: 2.2rem;
  }
  .tooltipbox {
    position: absolute;
    bottom: calc(100% - 2.3rem);
    left: -2.3rem;
    display: none;
    background-color: transparent;
    padding-bottom: 3.8rem;
    min-width: 21rem;
    width: 100%;
  }
  .tooltip {
    border-radius: ${({ theme }) => theme.borderRadius.x2};
    &:after {
      border-bottom-right-radius: 0.4rem;
      top: calc(100% - 0.85rem);
      height: 1.7rem;
      width: 1.7rem;
      right: unset;
      left: 2.5rem;
    }
  }
  margin-left: 0.8rem;
  height: 2.8rem;
  width: 2.8rem;
`;

export const TitleAndDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: end;
`;
